// REACT
import React, {Component} from 'react';

// GRID
import { Container } from 'react-grid-system';

// STYLES
import styled from 'styled-components';
import Colors from '../../shared/colors';

// IMAGE
import BackgroundGrey from '../../images/backgroundGrey.png'

// MODAL
import Modal from 'react-responsive-modal';
import { lighten } from "polished";

export default class MainDishes extends Component {
    constructor(){
        super();
        this.state = {
            open: false,
        }
    }

    onOpenModal = () => {
        this.setState({ open: true });
      };
    
    onCloseModal = () => {
        this.setState({ open: false });
    };


    renderItems = () => {
        const {
            data
        } = this.props;

        let dishe = data.menus;
        let dataReturn = [];
        for (let i = 0; i <= dishe.length-1; i++) {
            if (i <= 3){
                dataReturn.push(
                    <CardRow className="mb-20" key={i}>
                        <Image>
                            <img src={dishe[i].media.path} alt={dishe[i].name}/>
                        </Image>
                        <Text>
                            <Name>
                                {dishe[i].name}
                            </Name>
                            {
                                dishe[i].ingredients !== "" &&
                                    <Type>
                                        {dishe[i].ingredients}
                                    </Type>
                            }   
                        </Text>
                        {
                            dishe[i].price !== null &&
                                <Price>
                                    {dishe[i].price} {data.currency.symbol}
                                </Price>
                        }
                    </CardRow>
                )
            }
            if (i === 3) {
                return dataReturn;
            }
        }
    }

    render() {
        const {
            data,
            t
        } = this.props;

        const { 
            open 
        } = this.state;
        
        const Right = styled.div `
            width: 60%;
            height: 509px;
            background-size: cover;
            background-position: fixed;
            background-repeat: no-repeat;
            background-image: url(${data.menusCover[0].path});

            @media screen and (max-width: 992px) {
                display: none;
                height: initial;
            } 
        `
        return(
            <Master>
                <Container>
                    <Title>
                        {data.quote}
                    </Title>
                    <Content>
                        <Background>
                            <Left>

                            </Left>
                            <Right>
                                
                            </Right>
                        </Background>
                        <Card>
                            <CardTitle>
                                {t('Pricipais pratos')}
                            </CardTitle>
                            {
                               this.renderItems()
                            }
                            {
                                data.menus.length > 4 &&
                                    <ViewMore onClick={this.onOpenModal}>
                                        {t('VER MAIS')}
                                    </ViewMore>
                            }
                        </Card>
                    </Content>
                </Container>

                {/* MODALS */}
                <Modal open={open} onClose={this.onCloseModal} big>
                    <CardModal>
                        <CardTitle>
                            {t('Pricipais pratos')}
                        </CardTitle>
                        {
                            Object.values(data.menus).slice(0, 5).map((dishe, index) => {
                                return(
                                    <CardRow className="mb-20" key={index}>
                                        <Image>
                                            <img src={dishe.media.path} alt={dishe.name}/>
                                        </Image>
                                        <Text>
                                            <Name>
                                                {dishe.name}
                                            </Name>
                                            {
                                                dishe.ingredients !== "" &&
                                                    <Type>
                                                        {dishe.ingredients}
                                                    </Type>
                                            }   
                                        </Text>
                                        {
                                            dishe.price !== null &&
                                                <Price>
                                                    {dishe.price} {data.currency.symbol}
                                                </Price>
                                        }
                                    </CardRow>
                                )
                            })
                        }
                        </CardModal>
                </Modal>
            </Master>
        )
    }
}

const Master = styled.div `
    width: 100%;
    background-size: cover;
    background-position: fixed;
    background-repeat: no-repeat;
    background-image: url(${BackgroundGrey});
    padding-top: 70px;
    padding-bottom: 70px;
`
const Title = styled.div `
    max-width: 756px;
    color: #666666;
    font-family: "PT Sans";
    font-size: 36px;
    line-height: 48px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
    font-family: "PT Sans";
`
const Content = styled.div `
    margin-top: 50px;
    position: relative;
`
const Background = styled.div `
    display: flex;

    @media screen and (max-width: 992px) {
        display: block;
    } 
`
const Left = styled.div `
    width: 40%;

    @media screen and (max-width: 992px) {
        width: 100%; 
    } 
`
const Card = styled.div `
    width: 630px;
    min-height: 358px;
    background-color: #FFF;
    position: absolute;
    top: 42px;
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
    overflow-y: auto;
    box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.150);

    @media screen and (max-width: 992px) {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        top: 0px;
    } 

    @media screen and (max-width: 767px) {
        width: calc(100% - 40px)!important;
    }
`
const CardModal = styled.div `
    width: 800px;

    @media screen and (max-width: 900px) {
        width: calc(100% - 40px)!important;
        margin-left: 20px;
        margin-right: 20px;
    }
`
const CardTitle = styled.div `
    color: ${Colors.primary};
    font-family: "PT Sans";
    font-size: 36px;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 25px;
`
const CardRow = styled.div `
    display: flex;
    align-items: center;
`
const Image = styled.div `
    width: 48px;
    height: 48px;
    border-radius: 48px;
    margin-right: 10px;

    img {
        width: 48px;
        height: 48px;
        object-fit: cover;
        border-radius: 48px;
    }
`
const Text = styled.div `
    flex: 2;
`
const Name = styled.div `
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    margin-bottom: 5px;
`
const Type = styled.div `
    color: #000000;
    font-family: "PT Sans";
    font-size: 16px;
    line-height: 16px; 
`
const Price = styled.div `
    color: #000000;
    font-family: "PT Sans";
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
`
const ViewMore = styled.div `
    width: 140px;
    height: 40px;
    border-radius: 29px;
    line-height: 40px;
    background-color: #11837B;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: #FFF;
    cursor: pointer;
    font-size: 15px;
    -webkit-box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    font-family: "PT Sans";

    &:hover{
        background-color: ${lighten(0.05, Colors.primary)};
        transform: translateY(-3px);
        -webkit-box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.4);
        -moz-box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.4);
        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.4);
    }
`




// WEBPACK FOOTER //
// ./src/containers/MainDishes/mainDishes.container.js